<template>
    <SettingsCard title="Учёт времени">
        <div class="ds-settings-fields">
            <label class="ds-settings-field">Допустимое время опоздания (мин.) <base-input v-model="maxDelayTime"
                    max-length="3" type="number" class="ds-settings-input" @input="onChanges"></base-input></label>
            <label class="ds-settings-field">Допустимое время раннего ухода (мин.) <base-input v-model="maxEarlyLeavingTime"
                    max-length="3" class="ds-settings-input" @input="onChanges"></base-input></label>
            <label class="ds-settings-field">Время до начала смены для отметки (сек.) <base-input
                    v-model="timeForCheckinBeforeShift" max-length="3" class="ds-settings-input" @input="onChanges"></base-input></label>
        </div>
        <div class="ds-settings-actions">
            <btn @click="save" :disabled="isDisabled" :class="{ 'opacity-50': isDisabled }">Сохранить</btn>
        </div>
        <div v-if="saveError" class="ds-settings-error" role="alert">
            Не удалось сохранить настройки. <button type="button" @click="save">Повторить</button>
        </div>
    </SettingsCard>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useSettingsStore } from '@/stores/settingsStore'
import SettingsCard from '@/ui/SettingsCard.vue'

const settingsStore = useSettingsStore()
const maxDelayTime = ref(settingsStore.settings?.VIOLATION_TOLERANCE_MINUTES)
const maxEarlyLeavingTime = ref(settingsStore.settings?.VIOLATION_TOLERANCE_MINUTES_EXIT)
const timeForCheckinBeforeShift = ref(settingsStore.settings?.MAX_SECONDS_BEFORE_SHIFT_WHEN_EMPLOYEE_CAN_MAKE_CHECKIN)
const isDisabled = ref(true)
const changes = ref<any[]>([])
const saveError = ref(false)

const VIOLATION_TOLERANCE_MINUTES = 'VIOLATION_TOLERANCE_MINUTES'
const VIOLATION_TOLERANCE_MINUTES_EXIT = 'VIOLATION_TOLERANCE_MINUTES_EXIT'
const MAX_SECONDS_BEFORE_SHIFT_WHEN_EMPLOYEE_CAN_MAKE_CHECKIN = 'MAX_SECONDS_BEFORE_SHIFT_WHEN_EMPLOYEE_CAN_MAKE_CHECKIN'

const isChanged = (field:any, option:string) => {
    if(field.value != settingsStore.settings[option]) {
        if(!changes.value.includes(option)) changes.value.push(option)
    } else {
        changes.value = changes.value.filter((item:string) => item !== option)
    }
}

const onChanges = () => {
    isChanged(maxDelayTime, VIOLATION_TOLERANCE_MINUTES)
    isChanged(maxEarlyLeavingTime, VIOLATION_TOLERANCE_MINUTES_EXIT)
    isChanged(timeForCheckinBeforeShift, MAX_SECONDS_BEFORE_SHIFT_WHEN_EMPLOYEE_CAN_MAKE_CHECKIN)
    isDisabled.value = !changes.value.length
}

const save = async () => {
    const data:any = {}
    if(changes.value.includes(VIOLATION_TOLERANCE_MINUTES)) data.VIOLATION_TOLERANCE_MINUTES = maxDelayTime.value
    if(changes.value.includes(VIOLATION_TOLERANCE_MINUTES_EXIT)) data.VIOLATION_TOLERANCE_MINUTES_EXIT = maxEarlyLeavingTime.value
    if(changes.value.includes(MAX_SECONDS_BEFORE_SHIFT_WHEN_EMPLOYEE_CAN_MAKE_CHECKIN)) data.MAX_SECONDS_BEFORE_SHIFT_WHEN_EMPLOYEE_CAN_MAKE_CHECKIN = timeForCheckinBeforeShift.value
    const error = await settingsStore.changeSettings(data)
    if (error) {
        saveError.value = true
        return
    }

    saveError.value = false
    changes.value = []
}
</script>
